/* eslint-disable react/prop-types */
import React from 'react';

/**
 * Trend-bucket distribution for the Pause → Alert Impact page (041).
 *
 * `no_baseline` is rendered in a deliberately neutral style, never a success style:
 * it means "this user had no alerts in the 30 days before they started pausing, so
 * there is nothing to compare against" — an absence of evidence, not an improvement.
 * It is expected to be a large bucket, and a reader skimming a page sorted by
 * rate_delta could otherwise read it as a win (SC-004).
 */

const CARDS = [
  { key: 'decreased', label: 'Alerts decreased', tone: 'pai-good', hint: 'Fewer alerts per day during the pause window' },
  { key: 'increased', label: 'Alerts increased', tone: 'pai-bad', hint: 'More alerts per day during the pause window' },
  { key: 'unchanged', label: 'No change', tone: 'pai-flat', hint: 'Identical alert rate before and during' },
  { key: 'no_baseline', label: 'No baseline', tone: 'pai-unknown', hint: 'No alerts in the 30 days before — not comparable' },
];

const PauseAlertImpactSummaryCards = ({ totalUsers = 0, buckets = {}, subscribedUserCount = 0 }) => (
  <div className="au-cards pai-cards" data-testid="pai-summary-cards">
    <div className="au-card">
      <span className="au-card__label">Users analysed</span>
      <span className="au-card__value tnum" data-testid="pai-total-users">{totalUsers}</span>
      <span className="au-card__hint">Breath sessions spanning 7+ days</span>
    </div>

    {CARDS.map(({ key, label, tone, hint }) => {
      const bucket = buckets[key] || { count: 0, pct: 0 };
      return (
        <div className={`au-card ${tone}`} key={key} data-testid={`pai-card-${key}`}>
          <span className="au-card__label">{label}</span>
          <span className="au-card__value tnum">
            {bucket.count}
            <small className="pai-pct"> ({bucket.pct}%)</small>
          </span>
          <span className="au-card__hint">{hint}</span>
        </div>
      );
    })}

    <div className="au-card">
      <span className="au-card__label">Subscribed</span>
      <span className="au-card__value tnum">{subscribedUserCount}</span>
      <span className="au-card__hint">Of the users analysed</span>
    </div>
  </div>
);

export default PauseAlertImpactSummaryCards;
